import cls from 'classnames';
import useConfig from 'packages/common/hooks/useConfig';
import React, { useEffect, useRef, useState } from 'react';
import DownloadBtnSvg from './images/share-download-btn.svg';
import StarDownImage from './images/star-down.svg';
import StarUpImage from './images/star-up.svg';
type DownloadBtnProps = {
  btnClickHandler: React.MouseEventHandler;
  shadowDomClassName?: string;
  containerClassName?: string;
};

const DownloadBtn: React.FC<DownloadBtnProps> = ({
  btnClickHandler,
  containerClassName = ''
}) => {
  const {
    t
  } = useConfig();
  const domPaddingLength = 16 * 2;
  const [fontSizeIndex, setFontSizeIndex] = useState(0);
  const fontClassNameArr = ['H1-Bold', 'H2-Bold', 'H3-Bold', 'H4-Bold', 'H4-Bold truncate'];
  const buttonWrapperDom = useRef<HTMLDivElement>(null);
  const buttonTextDom = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    const wrapperDom = buttonWrapperDom.current;
    const textDom = buttonTextDom.current;
    if (!wrapperDom || !textDom) return;
    if (fontSizeIndex === fontClassNameArr.length - 1) return;

    if (wrapperDom.getBoundingClientRect().width - textDom.getBoundingClientRect().width < domPaddingLength) {
      setFontSizeIndex(fontSizeIndex + 1);
    }
  }, [fontSizeIndex, setFontSizeIndex, buttonWrapperDom, buttonTextDom]);
  return <section className="download-btn-layout-wrapper">
      <section className={cls('download-btn-container', containerClassName)}>
        <div className={cls('btn-wrapper', 'text-center', fontClassNameArr[fontSizeIndex])} ref={buttonWrapperDom} style={{
        background: `url(${DownloadBtnSvg}) 0 0/100% 100% no-repeat`
      }} onClick={btnClickHandler}>
          <span ref={buttonTextDom}>{t('referral_optimize_landing_cta_download')}</span>
        </div>
      </section>
      <style jsx>{`
        .download-btn-layout-wrapper {
          padding: 0 36px;
        }

        .download-btn-container {
          max-width: 303px;
          width: 100%;
          padding: 5px 0 0;
          margin: 0 auto;
        }

        .btn-wrapper {
          height: 56px;
          line-height: 56px;
          padding: 0 26px;
          white-space: nowrap;
          color: #fe2c55;
          text-shadow: 0px 2.11765px 0px rgba(255, 255, 255, 1);
          position: relative;
          animation: float ease-in-out 1.2s infinite;
        }
        .btn-wrapper::before {
          content: '';
          position: absolute;
          width: 28px;
          height: 13px;
          top: -5px;
          left: 86px;
          background: url(${StarUpImage}) 0 0/100% 100% no-repeat;
        }
        .btn-wrapper::after {
          content: '';
          position: absolute;
          width: 49px;
          height: 14px;
          bottom: -6px;
          right: 78px;
          background: url(${StarDownImage}) 0 0/100% 100% no-repeat;
        }

        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-6px);
          }
          100% {
            transform: translateY(0px);
          }
        }
      `}</style>
    </section>;
};

export default DownloadBtn;